import { Box, RadioButton, RadioGroup } from "@modernatx/ui-kit-react";
import React from "react";

import { PaymentScheduleOptions } from "@/components/Payments/AutoPayModal/SchedulePayModal";

interface InvoiceDueDateProps {
  invoiceId?: string | string[];
  paymentScheduleOptions: PaymentScheduleOptions;
  setPaymentScheduleOptions: React.Dispatch<
    React.SetStateAction<PaymentScheduleOptions>
  >;
  isInvoiceOverdue?: boolean;
}

const InvoicePaymentScheduleForm: React.FC<InvoiceDueDateProps> = ({
  invoiceId,
  paymentScheduleOptions,
  setPaymentScheduleOptions,
  isInvoiceOverdue
}) => {
  const isScheduledPay = !!invoiceId;

  const radioLabel = isScheduledPay
    ? `Pay invoice ${invoiceId}`
    : "Pay all invoices";

  const handleSelectionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value as PaymentScheduleOptions;
    setPaymentScheduleOptions(value);
  };

  return (
    <Box sx={{ mb: "spacing-6" }}>
      <RadioGroup
        label={radioLabel}
        value={paymentScheduleOptions}
        onChange={handleSelectionChange}
      >
        {isInvoiceOverdue ? (
          <RadioButton
            label="Specific date"
            value={PaymentScheduleOptions.SpecificDate}
          />
        ) : (
          <>
            <RadioButton
              label="On the due date"
              value={PaymentScheduleOptions.OnDueDate}
            />
            <RadioButton
              label="1 day before the due date"
              value={PaymentScheduleOptions.OneDayBefore}
            />
            <RadioButton
              label="2 days before the due date"
              value={PaymentScheduleOptions.TwoDaysBefore}
            />
            {isScheduledPay && (
              <RadioButton
                label="Specific date"
                value={PaymentScheduleOptions.SpecificDate}
              />
            )}
          </>
        )}
      </RadioGroup>
    </Box>
  );
};

export default InvoicePaymentScheduleForm;
